'use strict'
jQuery(document).ready(function() {
    jQuery('form[data-single-submit]').each(function() {
        jQuery(this).on('submit', function() {
            jQuery(this)
                .find('input[type="submit"], button[type="submit"]')
                .prop('disabled', true)
        })
    })
})
